export default __webpack_public_path__ + "static/media/GaneshchaturtiNew1.5a53eb95.JPG";